import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class PwaInstallService {
    private deferredPrompt: any;
    public showInstallButton = false;

    private readonly COOLDOWN_MS = 24 * 60 * 60 * 1000; // 24 hours

    constructor() {
        window.addEventListener('beforeinstallprompt', (event) => {
            event.preventDefault();
            this.deferredPrompt = event;

            if (!this.isInstalled() && !this.isSkippedRecently()) {
                this.showInstallButton = true;
            }
        });

        window.addEventListener('appinstalled', () => {
            this.showInstallButton = false;
            this.deleteCookie('pwa-skip');
        });
    }

    promptInstall(): void {
        if (this.deferredPrompt) {
            this.deferredPrompt.prompt();
            this.deferredPrompt.userChoice.then(() => {
                this.deferredPrompt = null;
                this.showInstallButton = false;
            });
        }
    }

    skipInstall(): void {
        this.showInstallButton = false;
        this.setCookie('pwa-skip', Date.now().toString(), 1); // expire in 1 day (controlled by isSkippedRecently)
    }

    isInstalled(): boolean {
        const isStandaloneDisplayMode = window.matchMedia('(display-mode: standalone)').matches;
        const isStandaloneNavigator = (window.navigator as any).standalone === true;
        return isStandaloneDisplayMode || isStandaloneNavigator;
    }

    private isSkippedRecently(): boolean {
        const lastSkip = this.getCookie('pwa-skip');
        if (!lastSkip) return false;

        const lastSkipTime = parseInt(lastSkip, 10);
        return Date.now() - lastSkipTime < this.COOLDOWN_MS;
    }

    // ---------------- COOKIE HELPERS ----------------

    private setCookie(name: string, value: string, days: number): void {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
    }

    private getCookie(name: string): string | null {
        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return match ? match[2] : null;
    }

    private deleteCookie(name: string): void {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }
}
